import { toast as toastify } from 'react-toastify';

function Toast({ message }) {
  let title = '';
  if (message.message) {
    title = message.title;
    message = message.message;
  }

  return (
    <>
      {!!title && <h5 className="font-bold mb-1">{title}</h5>}
      {message}
    </>
  );
}

const wrapToast = (orgFn, kind) => {
  return (message, opts) => {
    return orgFn(
      (props) => (
        <>
          <Toast message={message} kind={kind} {...props} />
        </>
      ),
      opts
    );
  };
};

const toast = wrapToast(toastify);
toast.info = wrapToast(toastify.info, 'info');
toast.success = wrapToast(toastify.success, 'success');
toast.warning = wrapToast(toastify.warning, 'warning');
toast.error = wrapToast(toastify.error, 'error');

export { toast };
